import React from 'react';

import { CardBottom, CardMedia, CardName, CardPrices, CardTop, type TokenCardProps } from '@pkg/components';
import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { normalizeAddress } from '@pkg/utils';

import { CardInside, Wrapper } from './styles';

export const TokenCard = ({
    item,
    yatPageItem,
    groupItem,
    cardSize,
    hideCollectionData,
    isCollectionTile = false,
    collectionData,
    ...rest
}: TokenCardProps) => {
    const { imageUrl, id, animationUrl, collection, orders } = item || {};
    const [_chain, contract, tokenId] = id?.split('.') || [];
    const { activity_date } = yatPageItem || groupItem?.item || {};
    const { primary_yat, twitter } = groupItem?.owner || {};
    const ordersWithPricing = orders?.filter((order) => !!order.price);
    const collectionFloorPrice = collection?.marketData?.floorPrice || collectionData?.marketData?.floorPrice;

    const NFTItem = groupItem?.item?.item_type?.Nft || yatPageItem?.item_type?.Nft || {};
    const { image, animation_url, contract_address, token_id, collection_name, collection_image, slug, blockchain } =
        NFTItem || {};

    const chain = _chain || blockchain?.replaceAll(`"`, '')?.toLowerCase();
    const contractAddress = contract || normalizeAddress(contract_address || '');
    const serializedItem =
        item ||
        ({
            imageUrl: image,
            animationUrl: animationUrl,
            id: `${chain}.${contractAddress}.${token_id}`,
            collection: {
                ...collectionData,
                slug,
                name: collection_name,
                imageUrl: collection_image,
            },
        } as Collectible);

    return (
        <Wrapper>
            <CardInside $cardSize={cardSize} $height={rest.height}>
                {cardSize !== 'small' && (
                    <CardTop
                        owner_yat={primary_yat}
                        owner_twitter={twitter}
                        activity_date={activity_date}
                        cardSize={cardSize}
                    />
                )}
                <CardMedia
                    image_url={imageUrl || image}
                    animation_url={animationUrl || animation_url}
                    cardSize={cardSize}
                    item={item}
                />
                <CardName
                    item={serializedItem}
                    collectionData={serializedItem?.collection || collectionData}
                    cardSize={cardSize}
                    hideCollectionData={hideCollectionData}
                />
                {ordersWithPricing && ordersWithPricing?.length ? (
                    <CardPrices
                        cardSize={cardSize}
                        item={serializedItem}
                        floorPriceWei={collectionFloorPrice}
                        bordered={true}
                    />
                ) : null}
                <CardBottom
                    chain={chain}
                    contract={contractAddress}
                    token_id={tokenId || token_id}
                    collection_slug={collection?.slug}
                    isCollectionTile={isCollectionTile}
                />
            </CardInside>
        </Wrapper>
    );
};
